/**
 * 모바일 기기인지 감지하는 유틸리티 함수
 */
export const isMobileDevice = (): boolean => {
  // User Agent를 통한 모바일 기기 감지
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // 모바일 기기 패턴 매칭
  const mobileRegex =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

  // 터치 스크린 지원 여부 확인
  const hasTouchScreen =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // 화면 크기 기반 모바일 감지 (768px 이하)
  const isSmallScreen = window.innerWidth <= 768;

  return mobileRegex.test(userAgent) || (hasTouchScreen && isSmallScreen);
};

/**
 * iOS 기기인지 감지하는 함수
 */
export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Android 기기인지 감지하는 함수
 */
export const isAndroid = (): boolean => {
  return /Android/.test(navigator.userAgent);
};
